<template>
  <div class="nopads">
      <div class="row">
          <!-- Area -->
          <div class="col-sm-4 nopads pl-1 pr-1">
              <span class="span-title">{{ $t('velho_equipment.damage.area') }}</span>
              <input
                  v-model.number="item.area"
                  type="number"
                  min="0"
                  class="form-control form-control-sm"
              />
          </div>

          <!-- Percentage -->
          <div v-if="isPercentageVisible" class="col-sm-4 nopads pl-1 pr-1">
              <span class="span-title">{{ $t('velho_equipment.damage.percentage') }}</span>
              <input
                  v-model.number="item.percentage"
                  type="number"
                  min="0"
                  class="form-control form-control-sm"
              />
          </div>

          <!-- Damage Type -->
          <div class="col-sm-4 nopads pl-1 pr-1">
              <span class="span-title">{{ $t('velho_equipment.damage.type') }}</span>
              <select
                  v-model="item.damage_type"
                  class="form-select form-select-sm"
              >
                  <option :value="null">{{ $t('velho_equipment.damage.select_type') }}</option>
                  <option
                      v-for="option in damageTypeSelector"
                      :key="option.value"
                      :value="option.value"
                  >
                      {{ option.text }}
                  </option>
              </select>
          </div>

          <!-- Damage Category -->
          <div class="col-sm-4 nopads pl-1 pr-1">
              <span class="span-title">{{ $t('velho_equipment.damage.category') }}</span>
              <select
                  v-model="item.damage_category"
                  class="form-select form-select-sm"
              >
                  <option :value="null">{{ $t('velho_equipment.damage.select_category') }}</option>
                  <option
                      v-for="option in damageCategorySelector"
                      :key="option.value"
                      :value="option.value"
                  >
                      {{ option.text }}
                  </option>
              </select>
          </div>

          <!-- Repair Priority Level -->
          <div class="col-sm-6 nopads pl-1 pr-1">
              <span class="span-title">{{ $t('velho_equipment.damage.repair_priority_level') }}</span>
              <select
                  v-model="item.repair_priority_level"
                  class="form-select form-select-sm"
              >
                  <option :value="null">{{ $t('velho_equipment.damage.select_repair_priority_level') }}</option>
                  <option
                      v-for="option in repairPriorityLevelSelector"
                      :key="option.value"
                      :value="option.value"
                  >
                      {{ option.text }}
                  </option>
              </select>
          </div>
      </div>
  </div>
</template>

<script>
import {velhoHelper, repairPriorityLevels, damageCategories, damageTypes} from "@/components/mixins/VelhoMixin";

export default {
    name: 'VelhoEquipmentDamageEditor',
    components: {},
    mixins: [velhoHelper],
    props: {
        item: {
            type: Object
        },
        isPercentageVisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    computed: {
        damageTypeSelector() {
            return  Object.values(damageTypes).map(value => {
                return {
                    text: this.getVelhoDamageTypeString(value),
                    value: value
                }
            });
        },
        damageCategorySelector() {
            return  Object.values(damageCategories).map(value => {
                return {
                    text: this.getVelhoDamageCategoryString(value),
                    value: value
                }
            });
        },
        repairPriorityLevelSelector() {
            return  Object.values(repairPriorityLevels).map(value => {
                return {
                    text: this.getVelhoRepairPriorityLevelString(value),
                    value: value
                }
            });
        },
    },
    mounted() {
        if(!this.item.damage_type) { this.item.damage_type = null }
        if(!this.item.damage_category) { this.item.damage_category = null }
        if(!this.item.repair_priority_level) { this.item.repair_priority_level = null }
    },
    methods: {}
}
</script>
